var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{attrs:{"href":_vm.href,"rel":"noopener noreferrer","target":"_blank"}},[_c('img',_vm._b({attrs:{"src":_vm.src,"alt":"Logo"}},'img',_vm.$attrs,false))]):_c('img',_vm._b({attrs:{"src":_vm.src,"alt":"Logo"}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }